export default "__VITE_ASSET__BR9bpJXT__"